<div class="mat-dialog-container">
  <h2 mat-dialog-title class="dialog-title">
    <span class="title-text">{{message}}</span>
    <button mat-icon-button aria-label="close dialog" (click)="handleClose()" class="close-icon">
        <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>
    <mat-form-field class="w-px-300" *ngIf="!radio">
      <mat-label>Select</mat-label>
      <mat-select id="select" required title="Select" [(ngModel)]="choice">
        <mat-option *ngFor="let c of options;" [value]="c">{{ getDisplayValue(c) }}</mat-option>
      </mat-select>
    </mat-form-field>


    <ng-container *ngIf="radio">
      <mat-radio-group [(ngModel)]="choice" id="radio-group">
        <mat-radio-button *ngFor="let c of options;" [value]="c">{{ getDisplayValue(c) }}</mat-radio-button>
      </mat-radio-group>
    </ng-container>

  </mat-dialog-content>
  <mat-dialog-actions class="justify-flex-end">
    <button mat-raised-button color="primary" id="confirm-accept-button" (click)="confirm()"
      [disabled]="!choice">Confirm</button>
  </mat-dialog-actions>
</div>